var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefferingDomain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.86816 10.4961C1.86816 11.3912 2.22374 12.2496 2.85668 12.8826C3.48961 13.5155 4.34806 13.8711 5.24316 13.8711C6.13827 13.8711 6.99671 13.5155 7.62965 12.8826C8.26258 12.2496 8.61816 11.3912 8.61816 10.4961C8.61816 9.60099 8.26258 8.74254 7.62965 8.10961C6.99671 7.47667 6.13827 7.12109 5.24316 7.12109C4.34806 7.12109 3.48961 7.47667 2.85668 8.10961C2.22374 8.74254 1.86816 9.60099 1.86816 10.4961Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94784 16.0082C6.76612 15.419 5.42439 15.2317 4.12649 15.4746C2.82859 15.7176 1.64546 16.3775 0.756836 17.3542",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3818 10.4961C15.3818 10.9393 15.4691 11.3782 15.6387 11.7877C15.8084 12.1971 16.057 12.5692 16.3703 12.8826C16.6837 13.196 17.0558 13.4446 17.4653 13.6142C17.8748 13.7838 18.3136 13.8711 18.7568 13.8711C19.2 13.8711 19.6389 13.7838 20.0484 13.6142C20.4579 13.4446 20.8299 13.196 21.1433 12.8826C21.4567 12.5692 21.7053 12.1971 21.8749 11.7877C22.0445 11.3782 22.1318 10.9393 22.1318 10.4961C22.1318 9.60099 21.7763 8.74254 21.1433 8.10961C20.5104 7.47667 19.6519 7.12109 18.7568 7.12109C17.8617 7.12109 17.0033 7.47667 16.3703 8.10961C15.7374 8.74254 15.3818 9.60099 15.3818 10.4961Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.243 17.3544C22.3529 16.3769 21.1677 15.717 19.8679 15.4753C18.5682 15.2336 17.225 15.4232 16.043 16.0154",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49316 4.6248C6.05374 3.52862 6.91696 2.61623 7.98045 1.99586C9.04393 1.37549 10.263 1.07319 11.4932 1.1248C12.7233 1.07319 13.9424 1.37549 15.0059 1.99586C16.0694 2.61623 16.9326 3.52862 17.4932 4.6248",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4932 4.625H17.9932V1.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 16.125H11.4651C11.1535 16.1252 10.8517 16.2338 10.6115 16.4322C10.3713 16.6306 10.2075 16.9064 10.1484 17.2123C10.0893 17.5182 10.1384 17.8352 10.2875 18.1088C10.4365 18.3824 10.676 18.5957 10.9651 18.712L13.0291 19.538C13.3181 19.6543 13.5577 19.8676 13.7067 20.1412C13.8557 20.4148 13.9049 20.7318 13.8458 21.0377C13.7866 21.3436 13.6229 21.6194 13.3827 21.8178C13.1424 22.0162 12.8407 22.1248 12.5291 22.125H10.5001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 16.125V15.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 22.875V22.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 8.63281C17.7476 9.91521 19.9261 10.5533 22.1322 10.4438",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 8.63281C4.1988 9.91521 6.3773 10.5533 8.58339 10.4438",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferingDomain);
export default __webpack_public_path__ + "static/media/reffering-domain.6ba91e2c2bccdaf1b5d598d65cae56ad.svg";
export { ForwardRef as ReactComponent };